export const ADVANCED_SETTINGS_ADMIN_EMAILS = [
  'admin@kandrservices.com',
  'bcirlot@gmail.com',
];

export const canAccessAdvancedSettings = (user) =>
  ADVANCED_SETTINGS_ADMIN_EMAILS.includes(user?.email);
